import request from '@/utils/request'


// 查询结算流水列表
export function listAccount(query) {
  return request({
    url: '/account/account/list',
    method: 'get',
    params: query
  })
}

// 查询结算流水分页
export function pageAccount(query) {
  return request({
    url: '/account/account/page',
    method: 'get',
    params: query
  })
}

// 查询结算流水详细
export function getAccount(data) {
  return request({
    url: '/account/account/detail',
    method: 'get',
    params: data
  })
}

// 新增结算流水
export function addAccount(data) {
  return request({
    url: '/account/account/add',
    method: 'post',
    data: data
  })
}

// 修改结算流水
export function updateAccount(data) {
  return request({
    url: '/account/account/edit',
    method: 'post',
    data: data
  })
}

// 删除结算流水
export function delAccount(data) {
  return request({
    url: '/account/account/delete',
    method: 'post',
    data: data
  })
}
